import React, { useEffect, useState } from "react";
import { $demands, queryDems, changeDemsState } from "../logics/demands";
import { IDem } from "../logics/types";
import { DemandDoneBlock } from "../molecules/DemandDoneBlock";
import { DemandListItem } from "../molecules/DemandListItem";
import { ShowFreeDemand } from "../molecules/ShowFreeDemand";
import { ShowPayDemand } from "../molecules/ShowPayDemand";
import "../styles/troubleshoot.css";
import { useStore } from "effector-react";
import { isIntfAccessDenied, keyIntfShowDemRate } from "../../../common/disabledInterfaces";
import { $currentNotification, clearNotification } from "../../../common/ui/Header/logics/notificationsLogic";

interface IDemandList {
  demsUpd: boolean; 
  hideArchive?: boolean; 
  companyId: number; 
  accountId: number; 
  demandPayType: number; 
}

export const DemandList = ({
  demsUpd,
  companyId,
  accountId,
  demandPayType,
  hideArchive = true,
}: IDemandList) => {
  const [showDemIdx, setShowDemIdx] = useState(-1); //индекс заявки, которую открыли для просмотра
  const [rateSucces, setRateSucces] = useState(false); //успешно удалось оценить заявку
  const {loading, failMsg, allDems} = useStore($demands) //заявки
  const [showRate, setShowRate] = useState(!isIntfAccessDenied(keyIntfShowDemRate)) //глобальная переменная, указывающая на то, нужно ли показывать оценки(для КРК не нужно показывать)
  const [filteredDems, setFilteredDems] = useState<IDem[]>([]); //отфильтрованные заявки
  const [doneInform, setDoneInform] = useState(false);
  //эффект запускается если изменился список заявок, "показать/скрыть архивные записи" и типо видимых заявок(платные или бесплатные)
  useEffect(() => {
    updFilteredDems(); //обновляем фильтрованные заявки
  }, [allDems, hideArchive, demandPayType]);

  //эффект запускается, если из родительского компонента пришел сигнал, о том, что нужно полное обновление заявок
  useEffect(() => {
    updDems(); //обновляем заявки
  }, [demsUpd]);

  useEffect(() => {
    if (doneInform) {
      setRateSucces(false);
      setDoneInform(false);
    }
    
  }, [doneInform]);
  useEffect(()=>{
    if($currentNotification.getState()!==-1){
      let found = filteredDems.indexOf(filteredDems.find(e=>e.id.toString()===$currentNotification.getState().toString())!)     
      setShowDemIdx(found)
    }
  },[filteredDems])

  useEffect(() => {
    if (rateSucces) { //если удалось поставить оценку заявке
      updDems(); //обновляем заявки
      setShowDemIdx(-1); //закрываем окно просмотра конкретной заявки   
    }
  }, [rateSucces]);

  const updDems = () => {
      changeDemsState(false)
      queryDems({accountId: (accountId == -1 ? "" : `${accountId}`), companyId: `${companyId}`})
  };

  const updFilteredDems = () => {
    if (hideArchive) {
      if(demandPayType == -1) setFilteredDems(allDems.filter(d => d.isArchive != true))
      else {
        if(demandPayType===1)
          setFilteredDems(allDems.filter(d => d.isArchive != true && d.contractorDemandId !== 0))
          else setFilteredDems(allDems.filter(d => d.isArchive != true && d.contractorDemandId === 0))
      }
    } else {
      if(demandPayType == -1) setFilteredDems(allDems)
      else if(demandPayType === 1){
        setFilteredDems(allDems.filter(d => (d.contractorDemandId!==0)))
      } else{
        setFilteredDems(allDems.filter(d =>  d.contractorDemandId === 0))
      }
    }
  };
  if (allDems.length === 0) {
    if (loading) return <div>Загрузка данных...</div>;
    if (failMsg != "") return <div>{failMsg}</div>;
    return <div>Заявки не обнаружены!</div>;
  } else if(filteredDems.length == 0) {
    return <div>Заявки с такими параметрами не обнаружены!</div>
  }
  return (
    <>
      <div className="d-flex flex-wrap">
        {filteredDems.map((d, i) => (
          <DemandListItem key={i} dem={d} setDbClickIdx={setShowDemIdx} idx={i} hide={hideArchive && d.isArchive === true} showRate={showRate} />
        ))}
      </div>
      {showDemIdx !== -1 ? 
        filteredDems[showDemIdx].order === 0?
        <ShowFreeDemand dem={filteredDems[showDemIdx]} companyId={companyId} setShowIdx={setShowDemIdx} setSuccess={setRateSucces} showRate={showRate} />
        :  <ShowPayDemand dem={filteredDems[showDemIdx]} companyId={companyId} setShowIdx={setShowDemIdx} setSuccess={setRateSucces} showRate={showRate} />
      : <></>}
      {rateSucces && !doneInform ? 
        <DemandDoneBlock text={"Оценка успешно сохранена!"} informOnEnd={setDoneInform} />
        : <></>
      }
    </>
  );
};
